import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const faqs = [
    {
        q: "Meu cliente vai perceber que está falando com uma IA?",
        a: "Dificilmente. O agente é configurado com a linguagem, o nome e o estilo do seu negócio. Ele responde de forma natural, não segue um script rígido e lida bem com perguntas inesperadas.",
    },
    {
        q: "Preciso mudar alguma coisa no meu dia a dia?",
        a: "Não. Você continua usando sua agenda, seu WhatsApp e seu telefone normalmente. O agente trabalha em paralelo, sem exigir que você aprenda nenhuma plataforma nova.",
    },
    {
        q: "O que acontece quando o cliente faz uma pergunta que o agente não sabe responder?",
        a: "O agente reconhece quando precisa de um humano e transfere o atendimento pra você de forma natural, sem deixar o cliente sem resposta.",
    },
    {
        q: "Funciona com Google Agenda e outros sistemas?",
        a: "Sim, a principal integração é com o Google Agenda — a maioria dos consultórios e escritórios já usa. Outros sistemas são avaliados caso a caso durante a conversa inicial.",
    },
    {
        q: "E se eu quiser cancelar?",
        a: "Sem fidelidade mínima. Basta avisar com 30 dias de antecedência e encerramos sem burocracia.",
    },
    {
        q: "Qual a diferença de contratar a Degasperin IA e usar um chatbot comum?",
        a: "Chatbot segue um fluxo fixo — trava quando o cliente sai do script. O agente que eu implemento entende contexto, consulta sua agenda em tempo real, se adapta à conversa e age. É IA real, não um menu de opções disfarçado.",
    },
    {
        q: "Posso contratar só o WhatsApp agora e adicionar o agente de voz depois?",
        a: "Sim. Os dois produtos funcionam de forma independente e podem ser combinados a qualquer momento.",
    },
];

export const Faq = () => {
    return (
        <section id="faq" className="relative py-24 md:py-32 lg:py-40">
            <div className="max-w-3xl mx-auto px-6 md:px-12">
                <Reveal>
                    <p className="text-sm md:text-base font-semibold uppercase tracking-widest text-[#94B4FF] text-center">
                        FAQ
                    </p>
                    <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#F5F5F5] text-center">
                        Perguntas frequentes
                    </h2>
                </Reveal>

                <Reveal delay={0.1}>
                    <Accordion
                        type="single"
                        collapsible
                        className="mt-12 w-full space-y-3"
                        data-testid="faq-accordion"
                    >
                        {faqs.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="rounded-xl border border-[#1E1E28] bg-[#121218] px-5 transition-colors hover:border-[#3B6FFF]/40 data-[state=open]:border-[#3B6FFF]/50"
                            >
                                <AccordionTrigger className="py-5 text-left font-display text-base md:text-lg font-semibold text-[#F5F5F5] hover:no-underline">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-5 text-[#F5F5F5]/65 leading-relaxed">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
};

export default Faq;
